import { render, staticRenderFns } from "./CorrectOrder.vue?vue&type=template&id=37f6fdaa&scoped=true&"
import script from "./CorrectOrder.vue?vue&type=script&lang=js&"
export * from "./CorrectOrder.vue?vue&type=script&lang=js&"
import style0 from "./CorrectOrder.vue?vue&type=style&index=0&id=37f6fdaa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f6fdaa",
  null
  
)

export default component.exports